/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { PidxPdsModalWrapperService } from '@myprofile-ui/pidx-ui-components'
import { PidxEscapeHtmlPipe, PidxNewLineTransformPipe } from '@myprofile-ui/pidx-utils'
import { TranslateService } from '@ngx-translate/core'
import { Store } from '@ngxs/store'
import { DeleteAddress } from '../../store/editor.actions'
import { AddressDto } from '../../../../../../apps/myprofile-ui/src/app/services/address/address.service'
import { HttpHeaders } from '@angular/common/http'

@Injectable({
  providedIn: 'root',
})
export class MyProfileAddressDeleteHelperService {
  private _store = inject(Store)
  private _translateService = inject(TranslateService)
  private _pidxNewLineTransformPipe = inject(PidxNewLineTransformPipe)
  private _pidxEscapeHtmlPipe = inject(PidxEscapeHtmlPipe)
  private _pidxPdsModalWrapperService = inject(PidxPdsModalWrapperService)

  public isLastAddress(): boolean {
    return this._store.selectSnapshot(({ addressWidget }) => addressWidget.addresses)?.length === 1
  }

  public prepareDeleteItem(item: AddressDto, instanceId: string, headers?: HttpHeaders) {
    if (this.isLastAddress()) {
      this.showDeleteLastAddressModal()
    } else {
      this.showDeletePromptModal(item, instanceId, headers)
    }
  }

  /**
   * Show the modal if you hit the delete button and there is more than one item
   */
  public async showDeletePromptModal(item: AddressDto, instanceId: string, headers?: HttpHeaders) {
    const title = this._translateService.instant('pidpaw.editAddress.deleteConfirmationModal.title')
    const body = this._pidxNewLineTransformPipe.transform(this._pidxEscapeHtmlPipe.transform(item.formattedAddress ?? ''))
    const btnPrimary = this._translateService.instant('pidpaw.editAddress.deleteConfirmationModal.btnPrimary')
    const btnGhost = this._translateService.instant('pidpaw.editAddress.deleteConfirmationModal.btnGhost')

    const result = await this._pidxPdsModalWrapperService.openModal({ title, body, btnPrimary, btnGhost })
    if (result) {
      this._store.dispatch(new DeleteAddress(item.addressId as string, instanceId, headers)).subscribe()
    }
  }

  /**
   * Show the modal if you hit the delete button and it is the last phone number
   */
  public async showDeleteLastAddressModal() {
    const title = this._translateService.instant('pidpaw.editAddress.button.deleteAddress.label')
    const body = this._translateService.instant('pidpaw.deleteAddress.error.deleteLast')
    const btnPrimary = this._translateService.instant('pidpaw.deleteAddress.button.ok')

    await this._pidxPdsModalWrapperService.openModal({ title, body, btnPrimary })
  }
}
